import React from "react";
import "../../style/Menu.css";
import { NavLink } from "react-router-dom";


function Menu() {
  return (
    <div className="menu-container col-md-8 col-lg-8 col-xl-8">
      
      <h1 className="menu-title mb-3 fw-normal border-bottom text-left pb-2 mb-4">
        Menu
      </h1>

      <nav className="navbar navbar-expand-lg bg-body-tertiary bg-light">
        <div className="container-fluid">

          <button type="button" className="navbar-brand btn btn-link p-0 text-decoration-none">Navbar</button>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">

              <li className="nav-item">
                <NavLink className="nav-link active" to="/">Home</NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/automation-testcase">Link</NavLink>
              </li>

              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  Dropdown
                </button>

                <ul className="dropdown-menu">
                  <li><button type="button" className="dropdown-item">Action</button></li>
                  <li><button type="button" className="dropdown-item">Another action</button></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><button type="button" className="dropdown-item">Something else here</button></li>
                </ul>
              </li>

              <li className="nav-item">
                <span className="nav-link disabled" aria-disabled="true">Disabled</span>
              </li>

            </ul>

          </div>
        </div>
      </nav>

    </div>
  );
}

export default Menu;
